import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { resetPassword } from "../../../Redux/Actions/AuthActions/ResetPasswordAction";
import { useAppThunkDispatch } from "../../../Redux/hooks";
import AuthActionBtn from "../../Shared/AuthActionBtn/AuthActionBtn";
import PasswordInput from "../../Shared/PasswordInput/PasswordInput";

type Props = {
  email: string;
  otp: string;
  onBack: () => void;
};

const ForgotPasswordResetStep = ({ email, otp, onBack }: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppThunkDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPas, setShowPas] = useState(false);
  const [showConPas, setShowConPas] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const handleBack = () => {
    setPassword("");
    setConfirmPassword("");
    setShowPas(false);
    setShowConPas(false);
    onBack();
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    if (!passwordRegex.test(password)) {
      toast.error(
        "Password must be at least 8 characters with uppercase, lowercase, number, and special character (!@#$%^&*)."
      );
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setIsFetching(true);
    const result = await dispatch(
      resetPassword({
        email,
        token: otp,
        password,
        type: "otp",
      })
    );
    setIsFetching(false);

    if (result.success) {
      toast.success(
        "Password reset successful. You can now log in with your new password."
      );
      navigate("/login");
    } else {
      const message = result.message || "";
      if (message.toLowerCase().includes("token")) {
        toast.error(
          "Invalid or expired code. Go back and request a new code, then try again."
        );
      } else {
        toast.error(message || "Failed to reset password. Please try again.");
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="ForgotPasswordBox forgotPasswordStep"
      data-testid="reset-password-form"
    >
      <p className="forgotPasswordStepTitle">Set a new password</p>
      <p className="forgotPasswordStepHint">
        Choose a strong password for <strong>{email}</strong>
      </p>

      <PasswordInput
        value={password}
        onChange={setPassword}
        pHolder="New Password"
        showPas={showPas}
        setShowPas={setShowPas}
        belowTx={true}
      />
      <PasswordInput
        value={confirmPassword}
        onChange={setConfirmPassword}
        pHolder="Confirm Password"
        showPas={showConPas}
        setShowPas={setShowConPas}
        belowTx={false}
      />

      <AuthActionBtn
        isFetching={isFetching}
        buttonLabel="Reset Password"
        hideFooterLink
      />
      <span className="forgotPasswordBackLink">
        <button type="button" className="forgotPasswordLinkBtn" onClick={handleBack}>
          Back to verification code
        </button>
      </span>
    </form>
  );
};

export default ForgotPasswordResetStep;
